import React, { useState } from "react";
import { Button, Col, Form, Row, Card, message } from "antd";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { validations } from "../../../../config/validations/validations";
import { CheckOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../../store/app";
import { checkRoutingNumber } from "../../../../store/NumberManagementSlice";
import { CopyOutlined } from "@ant-design/icons";

const CheckForm: React.FC<any> = () => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [asteriskData, setAsteriskData] = useState<any>();

  const handleSubmit = (data?: any) => {
    setLoading(true);
    const payload = {
      action: "internal_whois",
      number: data?.number ? data?.number : "",
    };
    dispatch(checkRoutingNumber(payload))
      .then((res: any) => {
        setAsteriskData(res?.data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  const handleCopy = (data) => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    message.success("JSON copied to clipboard!");
  };

  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={[20, 0]} align={"middle"}>
          <Col xs={24} md={24} lg={12} xxl={12}>
            <InputBox.Text
              label="Number Routing"
              name={"number"}
              tooltip="A single phone number to request to be ported.
                    Must be in a domestic form (e.g. 0551234567 or 03123456)"
              required
              rules={[
                validations.required.text("Number"),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={12} md={12} lg={6} xl={5}>
            {/* <Form.Item label=' '> */}
            <Button type="primary" htmlType="submit" loading={loading}>
              <CheckOutlined /> Check Number
            </Button>
            {/* </Form.Item> */}
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button
              type="default"
              htmlType="reset"
              onClick={() => {
                setAsteriskData(null);
              }}
            >
              Clear
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </FormBox>
      {asteriskData?.fnrRes ? (
        <ul className="asteriskData">
          <li>
            <div className="lable">Number:</div>{" "}
            <div>{asteriskData?.fnrRes.number}</div>
          </li>
          <li>
            <div className="lable">Provider Code:</div>{" "}
            <div>{asteriskData?.fnrRes.provider_code}</div>
          </li>
          <li>
            <div className="lable">Provider ID:</div>{" "}
            <div>{asteriskData?.fnrRes.provider_id}</div>
          </li>
          <li>
            <div className="lable">Provider Name:</div>{" "}
            <div>{asteriskData?.fnrRes.provider_name}</div>
          </li>
        </ul>
      ) : null}
      {asteriskData?.numberListRes ? (
        <div style={{ padding: 20 }}>
          <h2>JSON Display</h2>
          <Card
            title="JSON Data"
            extra={
              <Button
                type="primary"
                icon={<CopyOutlined />}
                onClick={(e) => {
                  handleCopy(asteriskData?.numberListRes);
                }}
              >
                Copy
              </Button>
            }
            style={{ maxWidth: 800, margin: "auto", marginTop: 20 }}
          >
            <pre
              style={{
                maxHeight: "400px",
                overflowY: "auto",
                background: "#f8f9fa",
                padding: "10px",
                borderRadius: "5px",
                fontFamily: "monospace",
                fontSize: "14px",
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
              }}
            >
              {JSON.stringify(asteriskData?.numberListRes, null, 2)}
            </pre>
          </Card>
        </div>
      ) : null}
    </>
  );
};

export default CheckForm;
